import { render, staticRenderFns } from "./Catalog.vue?vue&type=template&id=1e1c9dec&scoped=true&"
import script from "./Catalog.vue?vue&type=script&lang=js&"
export * from "./Catalog.vue?vue&type=script&lang=js&"
import style0 from "./Catalog.vue?vue&type=style&index=0&id=1e1c9dec&scoped=true&lang=css&"
import style1 from "./Catalog.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1c9dec",
  null
  
)

export default component.exports